import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseEnabled = !!(supabaseUrl && supabaseAnonKey);

if (!supabaseEnabled) {
  console.info(
    'Supabase not configured — using API email/password auth (REACT_APP_BACKEND_URL or dev default http://127.0.0.1:8000).',
  );
}

export const supabase = supabaseEnabled
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;
